import { getPurchaseCommonEventParams } from 'modules/purchase/helpers/getPurchaseCommonEventParams'

import { IAppState } from 'models/store.model'

export const getPurchaseStartedEventParams = (state: IAppState) => {
  const {
    productId,
    trialPeriodPrice,
    stripePriceId,
    currency,
    screenName,
    stripeAccountName,
    fullPrice,
    trialPriceId,
    stripeAccountId,
  } = getPurchaseCommonEventParams(state)

  return {
    productId: trialPriceId ? productId : stripePriceId,
    priceDetails: {
      price: fullPrice,
      trial: !!trialPeriodPrice,
      currency,
    },
    screenName,
    stripeAccountName,
    stripeAccountId,
  }
}
